import React, { useEffect, useState } from "react";

import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import FilterContainer from "../../../components/common/FilterContainer";
import MultiSelect from "../../../components/common/MultiSelect";

import {
  Space,
  Select,
  Button,
  Form,
  DatePicker,
  Row,
  Col,
  Checkbox,
  Tabs,
} from "antd";

import {
  Renwalstatus,
} from "../../../data/renewals";
import { auth, db } from "../../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";

import "./Renewals.css";
import FilteredTable from "./FilteredTable";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

const RenewalsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "Lease Templates",
      "1",
      "",
      "",
      "/leasing/leases/lease-templates"
    ),
    RightBarMethod(
      "PDF Form Templates",
      "2",
      "",
      "",
      "/leasing/leases/pdf-form-templates"
    ),
  ]),

  RightBarMethod(
    " REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Lease Expiration Detail By Month", "3", "", "", "/"),
      RightBarMethod("Renewal Summary", "4", "", "", "/"),
    ]
  ),

  RightBarMethod(
    " HELP TOPICS",
    "t3",
    <i className="fa-solid fa-circle-question"></i>,
    [
      RightBarMethod("Send Lease Renewal Offers", "11", "", "", "/"),
      RightBarMethod("Send Renewal Letters", "12", "", "", "/"),
    ]
  ),
];

const options = [];
for (let i = 10; i < 36; i++) {
  options.push({
    label: i.toString(36) + i,
    value: i.toString(36) + i,
  });
}

function Renewals() {
  const [leases, setLeases] = useState([]);
  const [filteredData, setFilteredData] = useState(leases);
  const [properties, setProperties] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    setIsLoading(true);
    if (companyName) {
      const fetchLeases = async () => {
        const leaseRef = collection(db, "companies", companyName, "leases");
        const propertiesRef = collection(
          db,
          "companies",
          companyName,
          "properties"
        );
        const tenantRef = collection(db, "companies", companyName, "tenants");

        const properties = await getDocs(propertiesRef);
        const propertiesFetched = properties.docs.map((doc) => ({
          id: doc.id,
          
          value:
            doc.data()?.propertyNameAddress?.propertyName +
            " - " +
            doc.data()?.propertyNameAddress?.propertyAddressOne +
            " " +
            doc.data()?.propertyNameAddress?.city +
            ", " +
            doc.data()?.propertyNameAddress?.state +
            " " +
            doc.data()?.propertyNameAddress?.zipCode,
          ...doc.data(),
        }));
        const propertySelect = propertiesFetched.map((item) =>
          item.value.toString()
        );
        const tenants = await getDocs(tenantRef);
        const tenantsFetched = tenants.docs.map((doc) => ({
          id: doc.id,
          value:
            doc.data().profileInfo.firstName +
            " " +
            doc.data().profileInfo.lastName,
          ...doc.data(),
        }));
        try {
          const snapShot = await getDocs(leaseRef);
          const fetchedData = snapShot.docs.map((doc) => ({
            id: doc.id,
            property: propertiesFetched.find(
              (item) => item.id === doc.data().propertyId
            ),
            tenant: tenantsFetched.find(
              (item) => item.id === doc.data().tenantId
            ),
            ...doc.data(),
          }));
          setLeases(fetchedData);
          setFilteredData(fetchedData);
          setPropertyOptions(propertySelect);
          setTenants(tenantsFetched);
          setIsLoading(false);
        } catch (err) {
          console.log("Error while fetching data", err);
        }
      };
      fetchLeases();
    }

  }, [companyName]);

  const renwalbtn = [
    {
      key: "1",
      label: <Link to="?filter_type=all">All</Link>,
      children: <FilteredTable filteredData={filteredData} isLoading={isLoading}/>,
    },
    {
      key: "2",
      label: (
        <Link to="?filter_type=ReadytoCountersign">Ready to Countersign</Link>
      ),
      children: `No lease renewals found. 2`,
    },
    {
      key: "3",
      label: <Link to="?filter_type=OutforSigning">Out for Signing</Link>,
      children: `No lease renewals found. 3`,
    },
    {
      key: "4",
      label: <Link to="?filter_type=Printed">Printed</Link>,
      children: `No lease renewals found. 4`,
    },
  ];

  const onFinish = (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
  
    const valuesBeforeHyphen = properties.map((value) => value.split(" - ")[0]);
  
    const filteredDataSource = leases.filter((record) => {
      const tenantFilter =
        values.tenant === "" ||
        (
          record.tenant?.profileInfo?.firstName +
          " " +
          record.tenant?.profileInfo?.lastName
        )
          .toLowerCase()
          .includes(values.tenant.toLowerCase());
  
      const propertyNameFilter =
        valuesBeforeHyphen.length === 0 ||
        valuesBeforeHyphen.some((value) =>
          record.property?.propertyNameAddress?.propertyName
            ?.toLowerCase()
            .includes(value.toLowerCase())
        );
  
      const startDate = dayjs(values.startDate, "day");
      const endDate = dayjs(values.endDate, "day");
      const leaseEndDate = dayjs(record.leaseDates?.leaseEndDate, "YYYY-MM-DD");
  
      const dateFilter =
        startDate.isValid() &&
        endDate.isValid() &&
        (startDate.isBefore(endDate) || startDate.isSame(endDate)) &&
        (startDate.isBefore(leaseEndDate) || startDate.isSame(leaseEndDate)) &&
        (endDate.isAfter(leaseEndDate) || endDate.isSame(leaseEndDate));
  
      // Check if the monthToMonthFilter is needed based on the values.monthToMonth
      const monthToMonthFilter =
        values.monthToMonth === undefined ||
        values.monthToMonth === true ||
        (values.monthToMonth === false && record.leaseDates?.monthToMonth === false);
  
      return (
        (
          values.tenant === "" &&
          valuesBeforeHyphen.length === 0 &&
          values.startDate === "" &&
          values.endDate === "" &&
          (values.monthToMonth === undefined || values.monthToMonth === true)
        ) ||
        (
          values.tenant === "" &&
          valuesBeforeHyphen.length === 0 &&
          values.startDate === "" &&
          values.endDate === "" &&
          values.monthToMonth === false &&
          record.leaseDates?.monthToMonth === false
        ) ||
        (
          tenantFilter &&
          propertyNameFilter &&
          (values.startDate === "" || values.endDate === "" || dateFilter) &&
          (values.monthToMonth === undefined || values.monthToMonth === true || monthToMonthFilter)
        )
      );
    });
  
    setFilteredData(filteredDataSource);
  };
  
  

  const validateEndDate = (_, endDate) => {
    const startDate = form.getFieldValue("startDate");

    if (startDate && endDate && endDate.isBefore(startDate)) {
      return Promise.reject("End date must be greater than start date");
    }

    return Promise.resolve();
  };

  const onFinishFailed = (err) => {
    console.log("failed", err);
  };

  const [form] = Form.useForm();

  const initialValues = {monthToMonth: true};

  return (
    <>
      <div className="renewals">
        <PageHeading heading="Renewals" />
        <Row>
          <Col span={24}>
            <FilterContainer heading="Filter your renewals with the options below:">
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                autoComplete="off"
                colon={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={initialValues}
                form={form}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Properties">
                      <MultiSelect
                        options={propertyOptions}
                        callBackItems={setProperties}
                        placeholder="Search by property, group, or portfolio"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Tenant" name="tenant">
                      <Select
                        options={tenants}
                        placeholder="Search by tenants"
                        allowClear
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Status">
                      <MultiSelect
                        options={Renwalstatus}
                        placeholder="Search by status"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Lease Expirations Eligible for Renewal">
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Space direction="vertical">
                            <Form.Item name="startDate">
                              <DatePicker />
                            </Form.Item>
                          </Space>
                        </Col>
                        <Col>
                          <span>To</span>
                        </Col>
                        <Col>
                          <Space direction="vertical">
                            <Form.Item
                              name="endDate"
                              rules={[{ validator: validateEndDate }]}
                            >
                              <DatePicker />
                            </Form.Item>
                          </Space>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Include month to month tenants"
                      name="monthToMonth"
                      valuePropName="checked"
                    >
                      <Checkbox></Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
      </div>
      <div className="renawaltab">
        <div className="renwawlbtn">
          <Tabs defaultActiveKey="1" items={renwalbtn} />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={RenewalsRightBar} />
      </div>
    </>
  );
}
export default Renewals;
